"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionsWithOtherNodesDialog = void 0;
var actions_with_other_nodes_dialog_component_1 = require("./actions-with-other-nodes-dialog.component");
Object.defineProperty(exports, "ActionsWithOtherNodesDialog", { enumerable: true, get: function () { return actions_with_other_nodes_dialog_component_1.ActionsWithOtherNodesDialog; } });
